import { reject } from 'lodash-es';
import { useMutation } from '@apollo/client/react';
import MLink from '@mui/material/Link';
import { makeStyles } from 'tss-react/mui';
import { useAppContext } from '../../contexts/app';
import { removeEventCommentMutation, eventCommentsQuery } from '../../apollo/events';
import ConfirmButton from '../confirm-button';
import type { EventComment } from '../../types/EventComment';
import type { Event } from '../../types/Event';

const useStyles = makeStyles()((theme) => ({
  deleteLink: {
    marginLeft: theme.spacing(1)
  },
  button: {
    paddingBottom: 1,
    fontSize: 12,
  }
}));

type Props = {
  comment?: EventComment;
  event?: Event;
};

const DeleteEventCommentLink = ({ comment, event }: Props) => {
  const { loggedInUser } = useAppContext();
  const { classes } = useStyles();
  const [removeEventComment] = useMutation(removeEventCommentMutation, {
    update: (proxy, { data: { removeEventComment: removedComment } }) => {
      // update event query w/ updated membership object
      const eventQueryVariables = { eventId: event.id };
      const data = proxy.readQuery({
        query: eventCommentsQuery,
        variables: eventQueryVariables,
      });
      proxy.writeQuery({
        query: eventCommentsQuery,
        variables: eventQueryVariables,
        data: {
          ...data,
          event: {
            ...data.event,
            comments: reject(data.event.comments, ({ id }) => id === removedComment.id),
            commentCount: data.event.commentCount - 1,
          }
        }
      });
    }
  });

  if (!loggedInUser || (!event.permissions.editable && comment.user.id !== loggedInUser.id)) {
    return null;
  }

  const handleClick = () => {
    removeEventComment({
      variables: {
        id: comment.id
      }
    });
  };

  return (
    <span className={classes.deleteLink}>
      <ConfirmButton
        buttonComponent={MLink}
        component="button"
        onClick={handleClick}
        className={classes.button}
        label="Delete"
        confirmMessage="Are you sure you would like to delete this comment?"
      />
    </span>
  );
};

export default DeleteEventCommentLink;
